import { render, staticRenderFns } from "./oil.form.vue?vue&type=template&id=92eb50a6&scoped=true&"
import script from "./oil.form.vue?vue&type=script&lang=js&"
export * from "./oil.form.vue?vue&type=script&lang=js&"
import style0 from "./oil.form.vue?vue&type=style&index=0&id=92eb50a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92eb50a6",
  null
  
)

export default component.exports